import {FieldError} from 'module/CustomField/type/FieldError'

export function parseServerError(error?: any): string {
	let msg;
	if (error?.response?.data?.message) msg = error.response.data.message + ''
	else if (error?.data?.message) msg = error.data.message + ''
	else if (error?.message) msg = error.message + ''
	else if (error) msg = error + ''
	if (msg) msg = msg.replace(/\\n/g, '\n')
	return msg || ''
}

export function ensureFieldErrorList(error: any): FieldError[] {
	let ret = error?.response?.data
	if (!Array.isArray(ret)) {
		ret = [ret]
	}
	return ret.flatMap((x: string | null | undefined | FieldError) => {
		if (!x) return []
		if (typeof x === 'string') {
			return [{message: x}]
		} else {
			const fe = x as FieldError
			const {field, pos, message, connectionError, serverResponse} = fe
			return [{field, pos, message, connectionError, serverResponse}]
		}
	})
}